// extracted by mini-css-extract-plugin
module.exports = {"resourceHeader":"ResourceHeader_resourceHeader__1eH8-"};